module.exports = __webpack_public_path__ + "img/hvad-har-du-lavet-4.7d21ac90.png";